/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-disabled-item[_ngcontent-%COMP%]   .ea-edit-btn[_ngcontent-%COMP%]{position:absolute;right:0;padding:0;top:50%;transform:translateY(-50%)}"];
export { styles as styles };
